export interface TABLE_CONFIG_TYPE {
  header: HEADER_TABLE_CONFIG_TYPE[]
}

export interface HEADER_TABLE_CONFIG_TYPE {
  id: string
  name: string
}

export const TABLE_CONFIG: TABLE_CONFIG_TYPE = {
  header: [
    {
      id: 'receiptNo',
      name: 'เลขที่ใบรับเงินชั่วคราว'
    },
    {
      id: 'receiptdate',
      name: 'วันที่ออกใบรับเงินชั่วคราว'
    },
    {
      id: 'insuredName',
      name: 'ชื่อ-นามสกุลผู้เอาประกัน'
    },
    {
      id: 'policyNo',
      name: 'เลขที่กรมธรรม์'
    },
    {
      id: 'agentName',
      name: 'ตัวแทนผู้ออกใบรับเงินชั่วคราว'
    },
    {
      id: 'status',
      name: 'สถานะ'
    },
    {
      id: 'aging',
      name: 'Aging'
    },
    {
      id: 'branchName',
      name: 'สาขาตันสังกัด'
    }
  ]
}

export const STAFF_TABLE_CONFIG: TABLE_CONFIG_TYPE = {
  header: [
    {
      id: 'staffid',
      name: 'รหัสพนักงาน'
    },
    {
      id: 'staffname',
      name: 'ชื่อ-นามสกุลพนักงาน'
    },
    {
      id: 'branchmovementbranchname',
      name: 'ประจำสาขาต้นสังกัด'
    },
    {
      id: 'startdate',
      name: 'วันที่เริ่ม'
    },
    {
      id: 'enddate',
      name: 'วันที่สิ้นสุด'
    },
    {
      id: 'regularbranchname',
      name: 'ปฏิบัติงานแทนสาขา'
    }
  ]
}

export const POLICY_SEARCH_TABLE_CONFIG: TABLE_CONFIG_TYPE = {
  header: [
    {
      id: 'PolicyNo',
      name: 'เลขที่กธ.'
    },
    {
      id: 'FirstName',
      name: 'ชื่อ-สกุล ผู้เอาประกันภัย'
    },
    {
      id: 'PaidtoDate',
      name: 'วันครบกำหนดชำระเบี้ยประกัน'
    },
    {
      id: 'PolicyFlag',
      name: 'สถานะกรมธรรม์/ใบคำขอ'
    },
    {
      id: 'EmailAddress',
      name: 'E-mail'
    },
    {
      id: 'MobileNo',
      name: 'เบอร์โทรศัพท์ผู้เอาประกันภัย'
    }
  ]
}
